import { Component, OnInit, VERSION } from '@angular/core';
import { environment } from '../../../environments/environment';

/** Class for the app component that is bootstrapped to run the application
 */
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    standalone: false
})
export class FooterComponent implements OnInit {

	version = VERSION.full;	/** the Angular version */
	envProd = environment.production; /** whether we are production or not */
	yearCorporateDate: number;

	ngOnInit() {
		const newDate = new Date();
		this.yearCorporateDate = newDate.getFullYear();
	}
}